module.exports = __webpack_public_path__ + "nc_static/media/remoteConnection.6ab860bc.svg";